export default "__VITE_ASSET__h17VafnJ__"